import { useState, useEffect } from 'react';

const useMediaQuery = () => {
  const [mediaQuery, setMediaQuery] = useState({
    isSmallMobile: window.innerWidth < 480,
    isMobile: window.innerWidth >= 480 && window.innerWidth < 640,
    isTablet: window.innerWidth >= 640 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024,
  });

  useEffect(() => {
    const handleResize = () => {
      setMediaQuery({
        isSmallMobile: window.innerWidth < 480,
        isMobile: window.innerWidth >= 480 && window.innerWidth < 640,
        isTablet: window.innerWidth >= 640 && window.innerWidth < 1024,
        isDesktop: window.innerWidth >= 1024,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mediaQuery;
};

export default useMediaQuery;
